import { Content, InfoCard, Page } from '@backstage/core-components';
import { HomePageCompanyLogo, HomePageStarredEntities } from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid, makeStyles } from '@material-ui/core';
import {
  AnnouncementsCard,
  NewAnnouncementBanner,
} from '@backstage-community/plugin-announcements';
import TemabitLogoFull from './temabit-logo.jpeg';


// Styles
const useStyles = makeStyles((theme) => ({
  searchBarInput: {
    maxWidth: '60vw',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '50px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none',
  },
}));
const useLogoStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(5, 0),
  },
  svg: {
    width: 'auto',
    height: 100,
  },
  path: {
    fill: '#7df3e1',
  },
}));

const LogoFull = () => {
  return <img src={TemabitLogoFull} alt="Temabit Logo" style={{ width: '700px' }} />;
};

export const HomePage = () => {
  const classes = useStyles();
  const { container } = useLogoStyles();

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={6}>
            <HomePageCompanyLogo className={container} logo={<LogoFull />} />
            <Grid container spacing={8}>
              <Grid item md={12}>
                <NewAnnouncementBanner />
              </Grid>
            </Grid>
            <Grid container item xs={12} justifyContent="center">
              <HomePageSearchBar
                InputProps={{
                  classes: {
                    root: classes.searchBarInput,
                    notchedOutline: classes.searchBarOutline,
                  },
                }}
                placeholder="Search"
              />
            </Grid>

            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                {/* <Box mt={2}>
                  <HomePageToolkit tools={tools} />
                </Box> */}
                {/* <Box mt={2}> */}
                <InfoCard title="Starred Entities">
                  <HomePageStarredEntities />
                </InfoCard>
                {/* </Box> */}
              </Grid>
              <Grid item xs={12} md={6}>
                <InfoCard title="Announcements">
                  <AnnouncementsCard />
                </InfoCard>
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
